import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { TicketGate } from "../../components/ui/TicketGate";
import { SectionHeading } from "../../components/ui/SectionHeading";
import { CloudsLayer } from "../../components/ui/Decorations";

export default function BookActivity() {
  const navigate = useNavigate();
  const location = useLocation();
  const defaultCode = location.state?.code || "";
  const activitySlug = location.state?.activitySlug;

  return (
    <div className="relative pt-8 pb-16">
      <CloudsLayer />
      <div className="relative z-10">
        <div className="max-w-md mx-auto px-4">
          <SectionHeading eyebrow="Book an Activity" title="Book Aktivitas Seru!" />
        </div>
        <div className="mt-6">
          <TicketGate
            defaultCode={defaultCode}
            onValid={(ticket) => {
              sessionStorage.setItem("bltr_active_ticket", ticket.ticketCode);
              navigate("/my-booking", { state: { code: ticket.ticketCode, openActivity: activitySlug } });
            }}
          />
        </div>
      </div>
    </div>
  );
}
